import userEvents from './userEvents';
import aiRecommendationEvents from './aiRecommendationEvents';
import aiMusicGeneratorEvents from './aiMusicGeneratorEvents';
import remixerEvents from './remixerEvents';
import distributionEvents from './distributionEvents';
import discoveryEvents from './discoveryEvents';

const events = {
  ...userEvents,
  ...aiRecommendationEvents,
  ...aiMusicGeneratorEvents,
  ...remixerEvents,
  ...distributionEvents,
  ...discoveryEvents,
};

export default events;
